import { render, staticRenderFns } from "./DocsFilter.vue?vue&type=template&id=51b5885a"
import script from "./DocsFilter.vue?vue&type=script&lang=js"
export * from "./DocsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports